import {createSlice} from '@reduxjs/toolkit'

import generateTestInfo from '../thunks/generateTestInfo'
import fetchPayment from '../thunks/fetchPayment'
import addOrder from '../thunks/addOrder'
import fetchOrder from '../thunks/fetchOrder'
import generateTestPaymentInfo from '../thunks/generateTestPaymentInfo'
import fetchCart from '../thunks/fetchCart'
import processOrder from '../thunks/processOrder'
import fetchTransaction from '../thunks/fetchTransaction'

const initialState = {
  // Data fetched from and sent to server
  data: {
    order_id: '',
    payment_method_id: '1',
    gift_cards: [],
    merchant_id: '',
    currency_id: '',
    customer_card_id: '',
    card_type_id: '',
    card_number: '',
    card_cvv: '',
    card_exp_month: '',
    card_exp_year: '',
    redirect_url: '',
    order_3ds_auth_cycle: '',
    order_cardholder_auth: '',
    order_eci: '',
    order_cavv: '',
    order_xid: '',
    order_3ds_authentication_status: '',
    order_3ds_enrollment_status: '',
    order_3ds_version: '',
    order_3ds_ds_transaction_id: '',
    apply_customer_balance: ''
  },
  // Status and error message
  status: '',
  error: null,
  paypal: {
    token: null,
    data: null
  }
}

export const getCardTypeOption = (cardTypeOptions, cardType) => {
  return cardTypeOptions.filter(({value}) => value === cardType)
}

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    changePayment(state, action) {
      const {property, value} = action.payload
      state.data[property] = value
    },
    changePaymentStatus(state, action) {
      state.status = action.payload
    },
    bulkChangePayment(state, action) {
      if(action.payload && action.payload.length > 0) {
        action.payload.map(({property, value}) => {
          state.data[property] = value
        })
      }
    }
  },
  extraReducers: {
    // Fetch payment information from the server
    [fetchPayment.pending]: (state) => {
      state.status = 'loading'
    },
    [fetchPayment.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      state.data = { ...state.data, ...action.payload }
    },
    [fetchPayment.rejected]: (state, action) => {
      state.status = 'failed'
      if(action.payload) {
        state.error = action.payload.message
      } else {
        state.error = action.error.message
      }
    },
    // Update payment information on doAdd
    [addOrder.pending]: (state) => {
      state.status = 'loading'
    },
    [addOrder.fulfilled]: (state, action) => {
      state.status = ''
      state.data = { ...state.data, ...action.payload }
    },
    [addOrder.rejected]: (state, action) => {
      state.status = 'failed'
      if(action.payload) {
        state.error = action.payload.message
      } else {
        state.error = action.error.message
      }
    },
    // Update payment information on get_order
    [fetchOrder.fulfilled]: (state, action) => {
      if(action.payload.payment_token && action.payload.payment_method_id == 6) {
        state.data.payment_token = action.payload.payment_token
        state.data.payment_method_id = 6
      }

      if(action.payload.payment_method_ids.length === 1) {
        state.data.payment_method_id = action.payload.payment_method_ids[0]
      }

      if(action.payload.shipping_profile_id) {
        state.data.shipping_profile_id = action.payload.shipping_profile_id
      }

      if(!action.payload.shipping_information_required) {
        state.data.shipping_same = true
      }
    },
    // Generate test payment information
    [generateTestInfo.fulfilled]: (state, action) => {
      state.status = ''
      const {
          card_type_id,
          card_number,
          card_cvv,
          card_exp_month,
          card_exp_year,
        } = action.payload

      state.data = {
        ...state.data,
        card_type_id,
        card_number,
        card_cvv,
        card_exp_month,
        card_exp_year
      }
    },
    [generateTestPaymentInfo.pending]: (state) => {
      state.status = 'loading'
    },
    [generateTestPaymentInfo.fulfilled]: (state, action) => {
      state.status = ''
      const {
          card_type_id,
          card_number,
          card_cvv,
          card_exp_month,
          card_exp_year,
        } = action.payload

      state.data = {
        ...state.data,
        card_type_id,
        card_number,
        card_cvv,
        card_exp_month,
        card_exp_year
      }
    },
    [generateTestPaymentInfo.rejected]: (state, action) => {
      state.status = 'failed'
      if(action.payload) {
        state.error = action.payload.message
      } else {
        state.error = action.error.message
      }
    },
    // Update shipping profile when changing order
    'order/changeOrder': (state, action) => {
      if(action.payload.property === 'shipping_profile_id') {
        state.data.shipping_profile_id = action.payload.value
      }
    },
    // Resetting status when changing customer info or cart
    'customerInfo/changeCustomerInfoStatus': (state, action) => {
      if(!action.payload) {
        state.status = ''
      }
    },
    'discounts/removeDiscount': (state) => {
        state.status = ''
    },
    'cart/removeOrderOfferByID': (state) => {
        state.status = ''
    },
    'cart/removeOfferByKey': (state) => {
        state.status = ''
    },
    'customerInfo/changeCustomerInfo': (state, action) => {
      if(action.payload.property === 'email' && state.status === 'idle') {
        state.status = 'add-offers'
      }
    },
    // Update gift cards from generate_cart
    [fetchCart.fulfilled]: (state, action) => {
      if(action.payload.hasOwnProperty('gift_cards')) {
        state.data.gift_cards = action.payload.gift_cards
      }
    },
    // Set status to succeeded on view_transaction or process_order
    [fetchTransaction.fulfilled]: (state) => {
      state.status = 'succeeded'
    },
    [processOrder.fulfilled]: (state) => {
      state.status = 'succeeded'
    },
    [processOrder.rejected]: (state) => {
      state.status = ''
    }
  }
})

export const {
  changePayment,
  bulkChangePayment,
  changePaymentStatus
} = paymentSlice.actions

export default paymentSlice.reducer


// WEBPACK FOOTER //
// ./client/resources/js/checkout/redux/slices/paymentSlice.js